module.exports = __webpack_public_path__ + "static/img/t2.8195eca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t2.png
// module id = wiD/
// module chunks = 2